import { render } from "./IncidentsView.vue?vue&type=template&id=ef0aa380&scoped=true"
import script from "./IncidentsView.vue?vue&type=script&lang=js"
export * from "./IncidentsView.vue?vue&type=script&lang=js"

import "./IncidentsView.vue?vue&type=style&index=0&id=ef0aa380&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef0aa380"]])

export default __exports__